import {handleActions} from 'redux-actions';

import {
  key,
  set,
  reset,
  resetAll
} from './actions';


// you can use this as central application storage.
// feel free to use it as a template to build new stores and/or extend it
export const selectors = {
  generating: state => state[key].generating
};

const initialState = {
  generating: false
};

export default handleActions({
  [set]: (state, action) => ({
    ...state,
    [action.payload.key]: action.payload.value,
  }),
  [resetAll]: (state, action) => ({
    ...initialState,
  }),
  [reset]: (state, action) => ({
    ...state,
    [action.payload.key]: initialState[action.payload.key],
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/util/redux/storage/reducer.js